import { render } from "./MarkdownEditor.vue?vue&type=template&id=3fe74990&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"

import "./MarkdownEditor.vue?vue&type=style&index=0&id=3fe74990&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe74990"]])

export default __exports__